import { AzureADAppPermissionsModel } from '../../../../models/microsoft/azuread/profile/azure-adapp-permissions-model';
import { OnePageModelBase } from '../../../../orchestration/reports/models/onepage/one-page-model-base';

export class BaseOnePageMicrosoftModel extends OnePageModelBase {
  azureADAppPermissions: AzureADAppPermissionsModel;
  hasADResource: boolean;
  isO365: boolean;
}
